import React, { useState } from 'react';
import ContentPage from '../components/ContentPage';
import { useConfig } from '../context/ConfigContext';
import { publicApi } from '../lib/api';
import { Phone, Mail, Loader2 } from 'lucide-react';
import { trackPhoneClick } from '../lib/contact';
import { toast } from 'sonner';

export default function ContactPage() {
  const { config } = useConfig();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sending, setSending] = useState(false);

  const phone = config?.phone || config?.contact_phone;
  const email = config?.contact_email || config?.email;

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error('Merci de remplir tous les champs.');
      return;
    }
    setSending(true);
    try {
      await publicApi.submitContact(form);
      toast.success('Message envoyé ! Nous vous répondrons rapidement.');
      setForm({ name: '', email: '', message: '' });
    } catch (err) {
      toast.error('Erreur lors de l\u2019envoi. Réessayez plus tard.');
    } finally {
      setSending(false);
    }
  };

  return (
    <ContentPage
      pageId="contact"
      relatedLinks={[
        { to: '/zone-intervention', label: 'Consulter notre zone d\u2019intervention' },
        { to: '/comment-ca-marche', label: 'Découvrir comment fonctionne Mitonner' },
        { to: '/tarifs', label: 'Voir les tarifs' },
      ]}
    >
      <div data-testid="contact-dynamic" className="mb-6 space-y-6">
        <div className="flex flex-wrap gap-4">
          {phone && (
            <a href={`tel:${String(phone).replace(/\s/g, '')}`} onClick={() => trackPhoneClick('contact')} className="inline-flex items-center gap-2 bg-white rounded-xl border border-[#E3DED5] px-4 py-3 text-[#2A312C] hover:border-[#A5BBA8]" data-testid="contact-phone">
              <Phone className="w-4 h-4 text-[#A5BBA8]" /> {phone}
            </a>
          )}
          {email && (
            <a href={`mailto:${email}`} className="inline-flex items-center gap-2 bg-white rounded-xl border border-[#E3DED5] px-4 py-3 text-[#2A312C] hover:border-[#A5BBA8]" data-testid="contact-email">
              <Mail className="w-4 h-4 text-[#A5BBA8]" /> {email}
            </a>
          )}
        </div>

        <form onSubmit={submit} className="bg-white rounded-2xl border border-[#E3DED5] p-6 space-y-4" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <input type="text" placeholder="Votre nom" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="input-default" data-testid="contact-name-input" />
            <input type="email" placeholder="Votre e-mail" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-default" data-testid="contact-email-input" />
          </div>
          <textarea placeholder="Votre message" rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="input-default" data-testid="contact-message-input" />
          <button type="submit" disabled={sending} className="btn-primary inline-flex items-center gap-2" data-testid="contact-submit">
            {sending && <Loader2 className="w-4 h-4 animate-spin" />} Envoyer
          </button>
        </form>
      </div>
    </ContentPage>
  );
}
